import { amplitudePushEvent } from '@kavak/frontend-layout';

/**
 * Tracks an analytics event in Amplitude
 * @param event Name of the event
 * @param flow Flow to which the event belongs
 * @param data Additional event data (optional)
 */
export function trackEvent({
  event,
  flow,
  ...data
}: {
  event: string;
  flow: string;
  [key: string]: any;
}) {
  try {
    amplitudePushEvent({
      event,
      flow,
      ...data,
    });
  } catch (error) {
    console.error('Failed to push event to Amplitude:', error);
  }
}
